$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});


var $menu = $('.ns-nav');
var $dropdown = document.getElementById('ns-dropdown')

/*
// When the user clicks on the button, 
// toggle between hiding and showing the dropdown content
$( '.shop-button, .ns-dropdown' ).hover(function() {
  $dropdown.classList.toggle('show');
});

$( '.shop-button' ).click(function() {
  $dropdown.classList.toggle('show');
});

$( '.mfp-close' ).click(function() {
  $dropdown.classList.remove('show');
});

// Close the dropdown menu if the user clicks outside of it
$(document).mouseup(function (e) {
   if (!$menu.is(e.target) // if the target of the click isn't the container...
   && $menu.has(e.target).length === 0) // ... nor a descendant of the container
   {
     $dropdown.classList.remove('show');
  }
});
*/

/* Sidebar
************************************************** */

function openDropDown() {
  $('.sidenav').toggleClass('active');
}

function sidenavOpen() {
  $('.sidenav').toggleClass('open');
  $('body').toggleClass('sidebar-open');
}

$('#shopMenu, .closebtn').click(() => {
  sidenavOpen();
});


$('#shopMenu, .sidenav').hover(() => {
  openDropDown();
});

$('.hero').slick({
  fade: true,
  autoplay: true
});

/*
$( document ).scroll(function() {
  	var scrollTop = $(window).scrollTop();
  	var scrollBottom = $(window).scrollTop() + $(window).height();
    if(scrollBottom < $('.ns-slider').height() && scrollTop > $('.ns-slider').offset().top){
        $("body").addClass("scroll1");
      	$("body").removeClass("scroll2");
      	$("body").removeClass("scroll2");
    } else if (scrollBottom < $('.ns-slider').height() && scrollTop < $('.ns-slider').offset().top) {
     	$("body").removeClass("scroll1");
      	$("body").addClass("scroll2");
      	$("body").removeClass("scroll2");
    } else if ( scrollBottom > $('.ns-slider').height() ) {
      $("body").removeClass("scroll1");
      $("body").removeClass("scroll2");
      $("body").addClass("scroll3");
    }
});
*/




jQuery(document).ready(function($){
  //customizable variables
  /* used too offset the window min and max for processing the scroll */
  var threshold_offset = 50;
  /* the element to scroll */
  var $container = $("#container");
  /* the element's container (which its to scroll within) */
  var $main = $("#product-main");
  //leave these ones.
  var $window = $(window);
  var window_min = 0;
  var window_max = 0;

  /*
   set the container's maximum and minimum limits as well as movement thresholds
  */
  function set_limits(){
    
    if ($('body.template-product').length > 0) {
   
      //max and min container movements
      var max_move = $main.offset().top + $main.height() - $container.height() - 2*parseInt($container.css("top") );
      var min_move = $main.offset().top;

      //save them
      $container.attr("data-min", min_move).attr("data-max",max_move);

      //window thresholds so the movement isn't called when its not needed!
      //you may wish to adjust the freshhold offset
      window_min = min_move - threshold_offset;
      window_max = max_move + $container.height() + threshold_offset;
      
    }
  }
  //sets the limits for the first load
  set_limits();

  function window_scroll(){
    //if the window is within the threshold, begin movements
    if( $window.scrollTop() >= window_min && $window.scrollTop() < window_max ){
      //window scroll is within range
      //reset the limits (optional)
      set_limits();
      //move the container
      container_move();
    }
  }
  $window.bind("scroll", window_scroll);

  /**
   * Handles moving the container if needed.
  **/
  function container_move(){
    
    
    var wst = $window.scrollTop();

    //if the window scroll is within the min and max (the container will be "sticky"
    if( wst >= $container.attr("data-min") && wst<= $container.attr("data-max") ){
      //work out the margin offset
      var margin_top = $window.scrollTop() - $container.attr("data-min");

      //margin it down!
      $container.css("margin-top", margin_top);

    //if the window scroll is below the minimum
    }else if( wst <= $container.attr("data-min") ){
		
      //fix the container to the top.
      $container.css("margin-top",0);

    //if the window scroll is above the maximum
    }else if( wst > $container.attr("data-max") ){
		
      //fix the container to the top
      $container.css("margin-top", $container.attr("data-max")-$container.attr("data-min")+"px" );

    }
  }

});

	$('.search-link').click(function() {
		// Toggle dropdown menu on mobile
		$('.ph-search-dropdown').toggleClass('search-visible');
	});

